export default {
      id: "ic_settings_wheel-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_settings_wheel-usage",
      toString: function () {
        return this.url;
      }
    }